import * as React from "react";
import ParallaxContent from "../../common/ParallaxContent";
import { paths } from "../../../vars/paths";
import { BlockParallaxText } from "../../../fragments/blockParallaxTextFields";
import { Img } from "wmk-image";

type ParallaxTextProps = {
  block: BlockParallaxText;
};

export const ParallaxText = ({ block }: ParallaxTextProps) => {
  return (
    <ParallaxContent
      title={block.title}
      content={block.text.text}
      button={{
        show: true,
        to: paths.rel("team"),
        type: "internal",
        text: "Meet the Team",
      }}
      image={new Img(block.image)}
    />
  );
};

export default ParallaxText;
